import { useSearchQueryFilter } from '@aibees/elephant/hooks';
import { ElephantPresetType } from '@aibees/elephant/types';
import {
  useBrowsePresetApi,
  useCreatePresetMutationApi,
} from '@aibees/shared/api';
import { Preset } from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';

export function useSetRemovedDefaultBuyingTeam(item: Preset) {
  const api = useCreatePresetMutationApi();

  const { removeAllParams } = useSearchQueryFilter();

  return async () => {
    return api
      .mutateAsync({
        type: ElephantPresetType.DEFAULT_BUYING_TEAM_MATRIX_REMOVE,
        name: item.name,
        value: { value: item.value, remove: true },
      } as any)
      .then(() => {
        removeAllParams();
        baseQueryClient.invalidateQueries([
          useBrowsePresetApi.name,
          ElephantPresetType.DEFAULT_BUYING_TEAM_MATRIX_REMOVE,
        ]);
      });
  };
}
